import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import CustomInput from "components/CustomInput/CustomOutlinedInput";
import Button from "components/CustomButtons/CustomButton";
import CustomModal from "components/CustomModal/Modal";
import Snackbar from "components/Snackbar/Snackbar";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";

import {
  getParameters,
  saveParameters,
} from "views/Services/ParametersService";
import { Grid } from "react-loader-spinner";

export default function SecurityParameters({}) {
  const [parameters, setParameters] = useState({
    id: 0,
    days_force_change_password: 0,
    days_deactivate: 0,
    attempts_block_user: 0,
    time_to_wait_when_fail_login: 0,
    days_delete_unused_cards: 0,
    chat_for_customers: false,
    chat_for_agents: false,
  });
  const [modalSuccess, setModalSuccess] = useState(false);
  const [messageToast, setMessageToast] = useState("");
  const [toastMessage, setToastMessage] = useState(false);

  const dispatch = useDispatch();

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setParameters((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleAction = async (actionType) => {
    // Aquí iría el dispatch/fetch real
    setMessageToast(`Acción ejecutada: ${actionType}`);
    setToastMessage(true);
    setModalSuccess(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let parametersToSave = { ...parameters };
    if (parametersToSave.chat_for_customers !== true) {
      delete parametersToSave.chat_for_customers;
    }
    if (parametersToSave.chat_for_agents !== true) {
      delete parametersToSave.chat_for_agents;
    }
    const result = await dispatch(saveParameters(parametersToSave));
    if (result.payload.result) {
      setMessageToast("Parameters saved successfully");
      setModalSuccess(true);
    } else {
      setMessageToast(result.payload.message || "Error saving parameters");
      setToastMessage(true);
    }
  };

  useEffect(() => {
    if (localStorage.getItem("userType") !== "1") {
      window.location.href = "/admin/home";
    }
    getCurrentParameters();
  }, [dispatch]);

  const getCurrentParameters = async () => {
    try {
      const response = await dispatch(getParameters({}));
      if (response.payload.result) {
        const updatedFields = { ...parameters };
        Object.entries(response.payload.parameters).forEach(([key, value]) => {
          if (key == "chat_for_customers" || key == "chat_for_agents") {
            value = value == "1" ? true : false;
          }
          if (key in updatedFields) {
            updatedFields[key] = value;
          }
        });
        setParameters(updatedFields);
      }
    } catch (error) {
      console.error("Error fetching parameters:", error);
    }
  };

  return (
    <GridContainer
      justifyContent="center"
      alignItems="center"
      xs={12}
      sm={12}
      md={8}
      style={{ margin: "auto" }}
    >
      <Card>
        <CardBody>
          <form onSubmit={handleSubmit}>
            <GridContainer>
              <GridItem xs={12} sm={6} md={6}>
                <CustomInput
                  labelText="Days to deactivate account to force password change"
                  inputProps={{
                    name: "days_force_change_password",
                    value: parameters.days_force_change_password,
                    onChange: handleInputChange,
                    type: "number",
                    required: true,
                  }}
                  formControlProps={{ fullWidth: true }}
                />
              </GridItem>
              <GridItem xs={12} sm={6} md={6}>
                <CustomInput
                  labelText="Num. of days to deactivate user without activity"
                  inputProps={{
                    name: "days_deactivate",
                    value: parameters.days_deactivate,
                    onChange: handleInputChange,
                    type: "number",
                    required: true,
                  }}
                  formControlProps={{ fullWidth: true }}
                />
              </GridItem>
              <GridItem xs={12} sm={6} md={6}>
                <CustomInput
                  labelText="Login attempts to block user"
                  inputProps={{
                    name: "attempts_block_user",
                    value: parameters.attempts_block_user,
                    onChange: handleInputChange,
                    type: "number",
                    required: true,
                  }}
                  formControlProps={{ fullWidth: true }}
                />
              </GridItem>
              <GridItem xs={12} sm={6} md={6}>
                <CustomInput
                  labelText="Time to wait after failed login attempts (Minutes)"
                  inputProps={{
                    name: "time_to_wait_when_fail_login",
                    value: parameters.time_to_wait_when_fail_login,
                    onChange: handleInputChange,
                    type: "number",
                    required: true,
                  }}
                  formControlProps={{ fullWidth: true }}
                />
              </GridItem>
              <GridItem xs={12} sm={6} md={6}>
                <CustomInput
                  labelText="Num. of days to delete unused credit cards"
                  inputProps={{
                    name: "days_delete_unused_cards",
                    value: parameters.days_delete_unused_cards,
                    onChange: handleInputChange,
                    type: "number",
                    required: true,
                  }}
                  formControlProps={{ fullWidth: true }}
                />
              </GridItem>
              <GridItem xs={12} sm={6} md={6}>
                <CustomInput
                  labelText="Chat for customers"
                  inputProps={{
                    name: "chat_for_customers",
                    type: "checkbox",
                    checked: parameters.chat_for_customers,
                    onChange: handleInputChange,
                    style: { height: "20px", color: "green" },
                  }}
                  formControlProps={{ fullWidth: true }}
                />
              </GridItem>
              <GridItem xs={12} sm={6} md={6}>
                <CustomInput
                  labelText="Chat for agents"
                  inputProps={{
                    name: "chat_for_agents",
                    type: "checkbox",
                    checked: parameters.chat_for_agents,
                    onChange: handleInputChange,
                    style: { height: "20px", color: "green" },
                  }}
                  formControlProps={{ fullWidth: true }}
                />
              </GridItem>
            </GridContainer>
            <GridContainer style={{ marginTop: "20px" }}>
              <GridItem xs={12} sm={6} md={6}>
                <Button
                  variant="info"
                  onClick={() => handleAction("Remove expired cards")}
                  block
                >
                  Remove expired cards
                </Button>
              </GridItem>
              <GridItem xs={12} sm={6} md={6}>
                <Button
                  variant="info"
                  onClick={() => handleAction("Remove unused cards")}
                  block
                >
                  Remove unused cards
                </Button>
              </GridItem>
              <GridItem xs={12} sm={6} md={6}>
                <Button
                  variant="info"
                  onClick={() =>
                    handleAction("Deactivate accounts with no use")
                  }
                  block
                >
                  Deactivate accounts with no use
                </Button>
              </GridItem>
              <GridItem xs={12} sm={6} md={6}>
                <Button
                  variant="info"
                  onClick={() => handleAction("Force change password to users")}
                  block
                >
                  Force change password to users
                </Button>
              </GridItem>
            </GridContainer>
            <GridContainer style={{ marginTop: "20px" }}>
              <GridItem xs={12} sm={6} md={4}>
                <Button
                  variant="default"
                  type="button"
                  onClick={() => (window.location.href = "/admin")}
                  block
                >
                  Back
                </Button>
              </GridItem>
              <GridItem item xs={12} sm={6} md={4}>
                &nbsp;
              </GridItem>
              <GridItem xs={12} sm={6} md={4}>
                <Button variant="green" type="submit" block>
                  Save Changes
                </Button>
              </GridItem>
            </GridContainer>
          </form>
          <CustomModal
            title="Success"
            isOpen={modalSuccess}
            onClose={() => setModalSuccess(false)}
            privacy={false}
            id={"successModal"}
          >
            <GridContainer>
              <GridItem xs={12}>
                <span>{messageToast}</span>
              </GridItem>
              <GridItem xs={12}>
                <Button
                  color="primary"
                  onClick={() => setModalSuccess(false)}
                  block
                >
                  Ok
                </Button>
              </GridItem>
            </GridContainer>
          </CustomModal>
          <Snackbar
            style={{ zIndex: "3000" }}
            place="center"
            color="danger"
            message={messageToast}
            open={toastMessage}
            closeNotification={() => setToastMessage(false)}
            close
          />
        </CardBody>
      </Card>
    </GridContainer>
  );
}
